var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiscord(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.389 5.407A17.68 17.68 0 0 0 14.91 4a13.14 13.14 0 0 0-.574 1.191c-1.67-.251-3.324-.251-4.963 0-.155-.373-.386-.842-.581-1.191a17.62 17.62 0 0 0-4.482 1.411C1.476 9.694.708 13.871 1.092 17.988c1.88 1.404 3.702 2.257 5.493 2.815.442-.609.837-1.256 1.176-1.937-.647-.246-1.267-.549-1.853-.902.155-.115.307-.235.454-.359 3.572 1.671 7.453 1.671 10.982 0 .149.124.301.244.454.359a11.54 11.54 0 0 1-1.856.903c.34.68.732 1.329 1.176 1.937 1.793-.558 3.616-1.411 5.496-2.816.451-4.773-.77-8.911-3.227-12.58zM8.248 15.456c-1.072 0-1.952-1.001-1.952-2.22s.861-2.222 1.952-2.222 1.97 1.001 1.952 2.222c.002 1.219-.861 2.22-1.952 2.22zm7.212 0c-1.072 0-1.952-1.001-1.952-2.22s.861-2.222 1.952-2.222 1.97 1.001 1.952 2.222c0 1.219-.86 2.22-1.952 2.22z",
    fill: "#222"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscord);
export default __webpack_public_path__ + "static/media/discord.33f823c2570d7601791cf48e6ffb9b6d.svg";
export { ForwardRef as ReactComponent };